import $ from 'jquery';

export default {

	init() {

      //E-card Preview: js-e-card-selection class is added through Advanced Tab in WPForms
			$('.js-e-card-selection select').on('change', function() {

				let selected_card = $(this).val().normalize('NFD').replace(/[\u0300-\u036f]/g, "");

        let handelized_card = selected_card.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
				let lang = ajax_object.lang;

        //The e-card file name should match the handlized name in the e-cards folder
        let card_src = ajax_object.file_path + "/images/e-cards/" + handelized_card + "_" + lang + ".jpg";

        let $card_html = $(`<img src="${card_src}" alt="${selected_card}" />`);

				//.js-img-wrapper is inside the HTML code block in the form
				$('.js-img-wrapper').html($card_html);

			});
	}
};
